<template>
  <div class="Kanit" style="color: black">
    <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
      งานที่กดรับ
    </div>

    <div v-if="jobs && jobs.length" class="pt-9">
      <v-card v-for="(job, k) in jobs" :key="k" outlined class="mt-3">
        <div class="pa-2">
          <div style="font-weight: 900; font-size: 11px">
            JobID : #{{ job.orderid }} ลูกค้า {{ job.customer_name }}
          </div>
          <div
            style="
              line-height: 9px;
              color: #08088a;
              font-size: 11px;
              margin-bottom: 20px;
            "
          >
            สถานะงาน : <span style="color: green !important">รับงานแล้ว</span>
          </div>
          <div class="px-3">
            <div style="display: flex; flex-direction: row">
              <div>
                <img
                  style="height: 60px; width: 80px"
                  :src="job.customer_profile_pic"
                />
              </div>
              <div
                style="align-self: center; margin-left: 20px; font-size: 10px"
              >
                ผู้จ้าง: {{ job.customer_name }}
              </div>
            </div>
            <div style="font-size: 10px; font-weight: bold">
              <div style="font-size: 13px">รายละเอียดงาน</div>
              <div style="line-height: 15px">
                ประเภทงาน: {{ job.work_type }}<br />
                พื้นที่การทาสี: {{ job.work_area }} ตรม.<br />
                สถานที่ปฏิบัติงาน: {{ job.customer_address }}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div
            style="background-color: #ededed; height: 60px"
            class="pa-3 whiteinput"
          >
            <v-text-field
              style="border-radius: 50px; font-size: 12px"
              outlined
              x-small
              :disabled="loading == job.orderid"
              dense
              v-model="job.note"
              placeholder="บันทึกความคืบหน้า"
            >
              <template v-slot:append-outer>
                <v-icon
                  v-if="loading !== job.orderid"
                  @click="
                    toapainterupdatenote(job.orderid, job.note ? job.note : '')
                  "
                  color="blue"
                  >mdi-send
                </v-icon>
                <div v-else>
                  <v-progress-circular
                    color="primary"
                    :size="20"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </template>
            </v-text-field>
          </div>
          <div v-for="(note, k) in job.history_note" :key="k" class="pa-3">
            <div class="noteblock">
              <div>
                <span class="mr-1" style="font-size: 13px; color: #08088a"
                  >Note : &nbsp;</span
                >
              </div>
              <div>
                <div>{{ note.note }}</div>
                <div style="line-height: 9px; color: #c20000">
                  {{ moment(note.time_to_note).format("DD MMMM YYYY, HH:mm") }}
                </div>
              </div>
            </div>
          </div>
          <div class="pa-3">
            <v-btn
              @click="gotoWorkForm(job.orderid)"
              small
              color="#4695da"
              outlined
              block
              rounded
              >แจ้งเริ่มงาน
            </v-btn>
            <v-btn
              @click="cantConnectUser(job.orderid)"
              class="mt-2"
              small
              color="#14af43"
              outlined
              block
              rounded
              >แจ้งลูกค้าไม่รับสาย
            </v-btn>
            <v-btn
              @click="clickCancel(job)"
              class="mt-1"
              small
              color="red"
              text
              block
              rounded
              >ยกเลิกงาน
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>
    <div v-else>
      <Nojob></Nojob>
    </div>

    <!-- Modal -->
    <v-dialog v-model="cancelModal" width="500px">
      <v-card class="Kanit">
        <v-card-text class="pa-3">
          <div
            class="text-center"
            style="font-weight: bold; font-size: 17px; color: black"
          >
            ยืนยันการยกเลิกงาน
          </div>
          <div
            style="
              font-size: 12px;
              line-height: 12px;
              margin-top: 15px;
              color: darkgrey;
            "
          >
            กรุณาแจ้งรายละเอียดการยกเลิกงาน เพื่อทำการบันทึกข้อมูลในระบบนะคะ
          </div>
          <div class="mt-5">
            <v-textarea
              v-model="input.remark"
              placeholder="เหตุผลที่ยกเลิกงาน"
              rows="5"
              style="font-size: 13px; border-radius: 12px"
              outlined
            ></v-textarea>
          </div>
          <div>
            <v-btn
              :loading="saveloading"
              @click="cancelJob"
              block
              color="primary"
              depressed
              small
              >ยืนยัน</v-btn
            >
            <v-btn
              :loading="saveloading"
              @click="cancelModal = false"
              block
              color="red"
              text
              small
              >ยกเลิก</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Nojob from "./Nojob.vue";

export default {
  components: {
    Nojob,
  },
  props: ["value"],
  data() {
    return {
      input: {
        remark: "",
      },
      saveloading: false,
      cancelModal: false,
      loading: "",
      currentCancel: "",
    };
  },
  computed: {
    jobs() {
      return this.value.orderlist.filter((el) => el.status == "กดรับงาน");
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    moment() {
      return moment;
    },
  },
  mounted() {},
  methods: {
    cantConnectUser(orderid) {
      var vm = this;
      this.$swal.fire({
        text: "ต้องการแจ้งไปหาลูกค้า?",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        showLoaderOnConfirm: true,
        cancelButtonText: "ยกเลิก",
        preConfirm: () => {
          return new Promise((resolve, reject) => {
            vm.loading = orderid;
            var body = {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: vm.query.pageid,
              orderid,
            };
            axios
              .post(
                "https://communitybotbyzwizai.herokuapp.com/toapainternotifycustomernotanswer",
                body,
                {
                  headers: {
                    AUTHORIZATION: "Bearer xxx xxx",
                  },
                }
              )
              .then((response) => {
                if (response.data.responsecode == 200) {
                  vm.$swal.fire({
                    icon: "success",
                    text: "สำเร็จ",
                  });
                }
                vm.loading = "";
                resolve();
              });
          });
        },
      });
    },
    gotoWorkForm(id) {
      this.query.orderid = id;
      this.$store.state.redirect = "PainterProfile";
      this.query.view = "WorkForm";
    },
    clickCancel(job) {
      this.cancelModal = true;
      this.currentCancel = job;
    },
    cancelJob() {
      var vm = this;

      vm.saveloading = true;
      var body = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: vm.query.pageid,
        orderid: vm.currentCancel.orderid,
        remark: vm.input.remark,
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toapaintercanceljobs",
          body,
          {
            headers: {
              AUTHORIZATION: '"Bearer xxx xxx"',
            },
          }
        )
        .then((response) => {
          vm.saveloading = false;
          if (response.data.responsecode == 200) {
            var orderid = vm.currentCancel.orderid;

            var index = vm.value.orderlist.findIndex(
              (el) => el.orderid == orderid
            );
            vm.$set(vm.value.orderlist, index, {
              ...vm.value.orderlist[index],
              status: "รอยกเลิกงาน",
            });
            vm.value.orderstatus.accepted--;
            vm.cancelModal = false;
            vm.currentCancel = "";
            // vm.value.splice(index, 1);
          } else if (response.data.responsecode == 400) {
            vm.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
          }
        });
    },
    toapainterupdatenote(orderid, note) {
      var vm = this;
      var body = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        orderid,
        note,
      };
      vm.loading = orderid;
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toapainterupdatenote",
          body,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          } else if (response.data.responsecode == 200) {
            var index = vm.value.orderlist.findIndex(
              (el) => el.orderid == orderid
            );
            vm.value.orderlist[index].note = "";
            vm.value.orderlist[index].history_note =
              response.data.data.history_note;
            vm.loading = "";
          }
        });
    },
  },
};
</script>

<style lang="scss">
.whiteinput .v-input__slot {
  background-color: white !important;
}
.noteblock {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  padding: 8px;
  padding-top: 2px;
  border: 1px solid #a7a7a7;
  border-radius: 15px;
  background-color: #f5f5f5;
  font-style: italic;
}
</style>